class PostHeadCodeInjector extends HTMLElement {
    connectedCallback() {
        const
        url = new URL(location.href),
        pathParts = url.pathname.split("/"),
        lastPart = pathParts[pathParts.length - 1],
        pageToInjectSlug = 'automate-digital-marketing-with-wix-zapier',
        isPageToInject = lastPart === pageToInjectSlug;

        if (isPageToInject) {
            document.querySelector("head")
            .insertAdjacentHTML("afterbegin", `
            <script class="custom-el-injection" type="module" src="https://cdn.zapier.com/packages/partner-sdk/v0/zapier-elements/zapier-elements.esm.js"></script>
            <link class="custom-el-injection" rel="stylesheet" href="https://cdn.zapier.com/packages/partner-sdk/v0/zapier-elements/zapier-elements.css" />
            `);
        } else {
            document.querySelectorAll(".custom-el-injection")?.length
            ? document.querySelectorAll(".custom-el-injection").forEach(el => {el.remove()})
            : null;
        }
    }
}

customElements.define('post-head-code-injector', PostHeadCodeInjector);
